module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table w100\">\n    ")
    ;  Util.each(attributes, function(attribute) { 
    ; __append("\n        ")
    ; 
            var control = _.reduce(attribute, function(result, value, field) {
                result['data-control-' + field] = value;
                return result;
            }, {});
        
    ; __append("\n\n        ")
    ;  if(!attribute.hidden) { 
    ; __append("\n            <div class=\"section\">\n                <div class=\"title\" style=\"overflow: hidden; text-overflow: ellipsis\">")
    ; __append(escapeFn( attribute.name ))
    ; __append("</div>\n                <div>\n                    <div ")
    ; __append( Html.attributes(control) )
    ; __append(">\n                        ")
    ; __append(escapeFn( attribute['html-value'] ))
    ; __append("\n                    </div>\n                </div>\n            </div>\n        ")
    ;  } else { 
    ; __append("\n            <div ")
    ; __append(escapeFn( control ))
    ; __append("></div>\n        ")
    ;  } 
    ; __append("\n    ")
    ;  }) 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}